/* eslint-disable functional/no-conditional-statement */
import { useOrderErrorEventValue } from "../../forms/hooks/useOrderErrorEventValue";
import { getPartnerPathnameClient } from "../../getPartnerPathnameClient";
import { DataTestids } from "../miscellaneous/DataTestids";
import { t } from "../miscellaneous/t";
import { useLocation } from "./useLocation";

export function useBuildOrderErrorEventMessage() {
  const { pathname } = useLocation();

  const isCartPage =
    `${getPartnerPathnameClient(true)}/purchases` === pathname ||
    `${getPartnerPathnameClient(true)}/samples` === pathname;
  const isConfirmPage =
    `${getPartnerPathnameClient(true)}/confirm` === pathname;

  const errorEvent = useOrderErrorEventValue();

  if (isCartPage) {
    if (errorEvent === DataTestids.CartManualEntryForm) {
      return t("mk-hc-manual-entry");
    } else if (errorEvent === DataTestids.SidebarForm) {
      return t("mk-hc-cart-title");
    } else {
      return "";
    }
  } else if (isConfirmPage) {
    return t("mk-hc-submit-order");
  } else {
    switch (errorEvent) {
      case DataTestids.AddressCreateForm:
        return t("mk-hc-enter-shipping-address");
      case DataTestids.AddressSubmitForm:
        return t("mk-hc-shipping-information");
      case DataTestids.ShippingForm:
        return t("mk-hc-shipping-options");
      case DataTestids.BillingAddressForm:
        return t("mk-hc-billing-address");
      case DataTestids.PaymentSavedForm:
        return t("mk-hc-payment");
      case DataTestids.SampleForm:
        return t("mk-hc-sample-questionnaire");
      default:
        return "";
    }
  }
}
